// extracted by mini-css-extract-plugin
export default {"side-image":"ChannelInvite_side-image__lhk8n"};